import { TaskableType } from '@hefe/models';
import {
  BasketballTeamSlice,
  TasksActions,
  usePrevious,
  userActiveBasketballCoachTeamId,
} from '@hefe/store';
import { Col, Row, Spin, Tabs } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';
import TasksAssignmentsComponent from '../../components/tasks-assignments/tasks-assignments.component';
import TasksListComponent from '../../components/tasks-list/tasks-list.component';
import { t } from '@hefe/i18n';

export default function TeamTasksPage() {
  const dispatch = useAppDispatch();

  const [loading, setLoading] = useState(false);

  const activeCoachId = useSelector(userActiveBasketballCoachTeamId);
  const prevActiveCoachId = usePrevious(activeCoachId);
  const tasks = useSelector(
    BasketballTeamSlice.basketballTeamTasksTeamSelector
  );

  const teamTasks = useSelector(
    BasketballTeamSlice.basketballTeamTasksTeamSelector
  );
  const clubTeamTasks = useSelector(
    BasketballTeamSlice.basketballTeamTasksClubSelector
  );

  useEffect(() => {
    fetchTasks();
    fetchPlayers();
  }, []);

  useEffect(() => {
    if (
      prevActiveCoachId !== undefined &&
      activeCoachId !== prevActiveCoachId
    ) {
      fetchTasks();
      fetchPlayers();
    }
  }, [activeCoachId]);

  const teamTasksMenuItems = useMemo(() => {
    return teamTasks.map((task) => ({
      label: task.name,
      key: 'team_' + task.id,
    }));
  }, [teamTasks]);

  const clubTeamTasksMenuItems = useMemo(() => {
    return clubTeamTasks.map((task) => ({
      label: task.name,
      key: 'club_' + task.id,
    }));
  }, [clubTeamTasks]);

  const tasksMenuItems = useMemo(() => {
    return [
      {
        label: t('tasks.team'),
        key: 'team',
        children: teamTasksMenuItems,
      },
      {
        label: t('tasks.club'),
        key: 'club',
        children: clubTeamTasksMenuItems,
      },
    ];
  }, [teamTasksMenuItems, clubTeamTasksMenuItems]);

  const fetchTasks = () => {
    setLoading(true);
    dispatch(
      TasksActions.fetchBasketballTeamTasks({
        teamId: activeCoachId ?? 0,
        withClubTasks: true,
      })
    )
      .unwrap()
      .finally(() => setLoading(false));
  };

  const fetchPlayers = () => {
    if (!activeCoachId) {
      return;
    }

    dispatch(
      BasketballTeamSlice.fetchBasketballTeamPlayersSelect({
        teamId: activeCoachId ?? 0,
        cacheDuration: 5 * 60 * 1000,
      })
    );
  };

  if (loading) {
    return (
      <Row align="middle" justify="center">
        <Col>
          <Spin size="large" />
        </Col>
      </Row>
    );
  }

  return (
    <Tabs
      items={[
        {
          key: 'assignments',
          label: 'Zuweisungen',
          children: (
            <TasksAssignmentsComponent
              type={TaskableType.BASKETBALL_TEAM}
              items={tasksMenuItems}
            />
          ),
        },
        {
          key: 'tasks',
          label: 'Mannschaftsaufgaben',
          children: (
            <TasksListComponent
              tasks={tasks}
              type={TaskableType.BASKETBALL_TEAM}
            />
          ),
        },
      ]}
    />
  );
}
